<template>
  <div class="sub-page"><div class="markdown" v-html="content"></div></div>
</template>

<script>
export default {
  data() {
    return {
      content: ''
    };
  },
  mounted() {
    // console.log(this.$route)
    this.getDetailCnt(this.$route.meta.typeid);
    this.getSeo();
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.getDetailCnt(this.$route.meta.typeid);
        this.getSeo();
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    getDetailCnt(typeid) {
      this.$https
        .fetchPost('/Article/article_detail', {
          id: typeid
        })
        .then(res => {
          // console.log(res.data)
          this.content = res.data.data.content;
          this.metaInfoAttr = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getSeo() {
      // this.$https.fetchPost('/api/getseo', {
      //   name: this.$route.name
      // }).then((res) => {
      //   // console.log(res.data.data)
      //   if (res.data.data) {
      //     this.metaInfoAttr = res.data.data
      //   }
      // })
    }
  },
  components: {}
};
</script>
<style lang="less">
.sub-page {
  padding: 25px 0;
  .markdown {
    img {
      display: inline-block;
    }
    * {
      max-width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assembly/articletemplate.vue